/* WFW-008-AB */
(function () {
  function entryFromButton(btn) {
    var tpl = btn.querySelector('template[data-bestsellers-rating-template]');
    var src = btn.getAttribute('data-img-src');
    var priceHtml = btn.getAttribute('data-price-html');
    var title = btn.getAttribute('data-title-text');
    if (!tpl && !src && !priceHtml && !title) return null;

    return {
      imgSrc: src || '',
      imgSrcset: btn.getAttribute('data-img-srcset') || '',
      priceHtml: priceHtml || '',
      title: title || '',
      url: btn.getAttribute('data-pdp-url') || '',
      reviewsMobileText: btn.getAttribute('data-reviews-mobile-text') || '',
      reviewsAriaLabel: btn.getAttribute('data-reviews-aria-label') || '',
      ratingHtml: tpl ? tpl.innerHTML : '',
    };
  }

  function applySwatch(root, btn, img, priceEl) {
    var entry = entryFromButton(btn);

    if (entry) {
      if (entry.imgSrc && img) {
        img.src = entry.imgSrc;
        if (entry.imgSrcset) {
          img.srcset = entry.imgSrcset;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-sizes');
        }
        img.classList.remove('lazyload');
        if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
          window.lazySizes.loader.unveil(img);
        }
      }
      if (entry.priceHtml && priceEl) priceEl.innerHTML = entry.priceHtml;

      var titleEl = root.querySelector('[data-bestsellers-card-title]');
      if (titleEl && entry.title) titleEl.textContent = entry.title;

      var ratingWrap = root.querySelector('[data-bestsellers-rating-wrap]');
      if (ratingWrap && entry.ratingHtml) ratingWrap.innerHTML = entry.ratingHtml;

      var mobileCount = root.querySelector('[data-bestsellers-reviews-mobile]');
      if (mobileCount && entry.reviewsMobileText) mobileCount.textContent = entry.reviewsMobileText;

      if (entry.url) {
        root.querySelectorAll('[data-bestsellers-pdp-link]').forEach(function (a) {
          a.href = entry.url;
        });
      }

      var imgLink = root.querySelector('.bestsellers-consolidated-card__image-link[data-bestsellers-pdp-link]');
      if (imgLink && entry.title) imgLink.setAttribute('aria-label', entry.title);

      var reviewsLink = root.querySelector('.bestsellers-consolidated-card__reviews-link[data-bestsellers-pdp-link]');
      if (reviewsLink && entry.reviewsAriaLabel) reviewsLink.setAttribute('aria-label', entry.reviewsAriaLabel);
    }

    root.querySelectorAll('[data-bestsellers-swatch]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.classList.toggle('selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function forceImageLoad(img) {
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) return;

    var dataSrcset = img.getAttribute('data-srcset');
    if (dataSrcset) {
      img.srcset = dataSrcset;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
    }

    var src = img.getAttribute('data-src') || img.getAttribute('src');
    if (src) {
      img.src = src;
    }

    img.classList.remove('lazyload');
    img.loading = 'eager';
    img.setAttribute('loading', 'eager');

    if (window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.unveil(img);
    }
  }

  function preloadOverflowSwatchImages(root) {
    root.querySelectorAll('.bestsellers-consolidated-card__sibling--overflow-mobile img').forEach(forceImageLoad);
  }

  /* WFW-008-AB — BUG 012: fit swatches to card width before +N */
  function isMobileSwatchLayout() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function fallbackSwatchWidth() {
    return isMobileSwatchLayout() ? 32 : 48;
  }

  function fallbackOverflowWidth() {
    return isMobileSwatchLayout() ? 36 : 48;
  }

  function measureOverflowWidth(btn, hiddenCount) {
    if (!btn) return fallbackOverflowWidth();
    var prevText = btn.textContent;
    var prevDisplay = btn.style.display;
    var prevVisibility = btn.style.visibility;
    var hadHidden = btn.classList.contains('bestsellers-consolidated-card__swatch-overflow-count--hidden');
    btn.classList.remove('bestsellers-consolidated-card__swatch-overflow-count--hidden');
    btn.textContent = '+' + hiddenCount;
    btn.style.display = 'inline-flex';
    btn.style.visibility = 'hidden';
    var width = btn.getBoundingClientRect().width;
    btn.textContent = prevText;
    btn.style.display = prevDisplay;
    btn.style.visibility = prevVisibility;
    if (hadHidden) btn.classList.add('bestsellers-consolidated-card__swatch-overflow-count--hidden');
    return width > 0 ? width : fallbackOverflowWidth();
  }

  function getSwatchWidth(sample) {
    var width = sample.getBoundingClientRect().width;
    return width > 0 ? width : fallbackSwatchWidth();
  }

  function getRowWidth(row, root) {
    var meta = root.querySelector('.bestsellers-consolidated-card__meta');
    if (meta && meta.clientWidth > 0) return meta.clientWidth;

    var width = row.getBoundingClientRect().width;
    if (width > 0) return width;

    var wrap = root.querySelector('.bestsellers-consolidated-card__variant-swatches') || root.querySelector('.bestsellers-consolidated-card__swatches');
    return wrap ? wrap.getBoundingClientRect().width : 0;
  }

  function rowWidthNeeded(visibleCount, swatchW, gap, overflowW) {
    if (visibleCount <= 0) return 0;
    return visibleCount * swatchW + (visibleCount - 1) * gap + (overflowW > 0 ? gap + overflowW : 0);
  }

  function maxVisibleForRow(row, root, swatches, overflowBtn) {
    var total = swatches.length;
    if (total <= 1) return total;

    var swatchW = getSwatchWidth(swatches[0]);
    var gap = parseFloat(window.getComputedStyle(row).columnGap || window.getComputedStyle(row).gap) || 0;
    var rowWidth = getRowWidth(row, root);
    if (!rowWidth) return null;

    var allWidth = rowWidthNeeded(total, swatchW, gap, 0);
    if (allWidth <= rowWidth) return total;

    var overflowW = measureOverflowWidth(overflowBtn, Math.max(1, total - 1));
    var visible;

    for (visible = total - 1; visible >= 1; visible -= 1) {
      if (rowWidthNeeded(visible, swatchW, gap, overflowW) <= rowWidth) return visible;
    }

    return 1;
  }

  function activeSwatchIndex(swatches) {
    for (var i = 0; i < swatches.length; i += 1) {
      if (swatches[i].classList.contains('is-active') || swatches[i].classList.contains('selected')) {
        return parseInt(swatches[i].getAttribute('data-bestsellers-swatch-index') || String(i + 1), 10);
      }
    }
    return 1;
  }

  function visibleSwatchIndices(total, maxVisible, activeIdx) {
    var visible = {};
    var limit = Math.min(maxVisible, total);
    var i;

    for (i = 1; i <= limit; i += 1) visible[i] = true;

    if (activeIdx > limit) {
      delete visible[limit];
      visible[activeIdx] = true;
    }

    return visible;
  }

  function updateOverflowAria(overflowBtn, hiddenCount) {
    var template = overflowBtn.getAttribute('data-overflow-aria-template');
    if (!template) return;
    overflowBtn.setAttribute('aria-label', template.replace('__COUNT__', String(hiddenCount)));
  }

  function layoutSwatchOverflow(root) {
    if (!root.classList.contains('bestsellers-consolidated-card--layout-grid')) return;
    if (root.classList.contains('is-swatch-expanded')) return;

    var row =
      root.querySelector('.bestsellers-consolidated-card__image-swatches') ||
      root.querySelector('.bestsellers-consolidated-card__shape-swatches') ||
      root.querySelector('.bestsellers-consolidated-card__variant-swatches');
    if (!row) return;

    var swatches = Array.prototype.slice.call(
      row.querySelectorAll('[data-bestsellers-swatch]')
    );

    var overflowBtn = row.querySelector('[data-bestsellers-swatch-expand]');
    var total = swatches.length;

    if (total <= 1) {
      if (overflowBtn) overflowBtn.classList.add('bestsellers-consolidated-card__swatch-overflow-count--hidden');
      root.setAttribute('data-swatch-layout-ready', 'true');
      return;
    }

    var maxVisible = maxVisibleForRow(row, root, swatches, overflowBtn);
    if (maxVisible === null) {
      var retries = parseInt(root.getAttribute('data-swatch-layout-retries') || '0', 10);
      if (retries < 8) {
        root.setAttribute('data-swatch-layout-retries', String(retries + 1));
        window.requestAnimationFrame(function () {
          layoutSwatchOverflow(root);
        });
        window.setTimeout(function () {
          layoutSwatchOverflow(root);
        }, 120);
      }
      return;
    }

    root.removeAttribute('data-swatch-layout-retries');
    var activeIdx = activeSwatchIndex(swatches);
    var visible = visibleSwatchIndices(total, maxVisible, activeIdx);
    var hiddenCount = 0;

    swatches.forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-bestsellers-swatch-index') || '0', 10);
      var hide = !visible[idx];
      btn.classList.toggle('bestsellers-consolidated-card__sibling--overflow-mobile', hide);
      if (hide) hiddenCount += 1;
    });

    if (overflowBtn) {
      if (hiddenCount > 0) {
        overflowBtn.classList.remove('bestsellers-consolidated-card__swatch-overflow-count--hidden');
        overflowBtn.textContent = '+' + hiddenCount;
        updateOverflowAria(overflowBtn, hiddenCount);
      } else {
        overflowBtn.classList.add('bestsellers-consolidated-card__swatch-overflow-count--hidden');
      }
    }

    root.setAttribute('data-swatch-layout-ready', 'true');
  }

  var resizeObserver = null;
  if (typeof window.ResizeObserver === 'function') {
    resizeObserver = new window.ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var root = entry.target.closest('[data-bestsellers-consolidated]');
        if (root) layoutSwatchOverflow(root);
      });
    });
  }

  function observeSwatchRow(root) {
    if (!resizeObserver) return;
    var row =
      root.querySelector('.bestsellers-consolidated-card__image-swatches') ||
      root.querySelector('.bestsellers-consolidated-card__shape-swatches') ||
      root.querySelector('.bestsellers-consolidated-card__variant-swatches');
    if (row && row.getAttribute('data-bestsellers-swatch-row-observed') !== 'true') {
      row.setAttribute('data-bestsellers-swatch-row-observed', 'true');
      resizeObserver.observe(row);
    }
  }

  function init(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll('.bestsellers-consolidated--var-2 [data-bestsellers-consolidated]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-bestsellers-v2-bound') === 'true') return;
      root.setAttribute('data-bestsellers-v2-bound', 'true');

      var img = root.querySelector('[data-bestsellers-main-img]');
      var priceEl = root.querySelector('[data-bestsellers-price]');

      root.querySelectorAll('[data-bestsellers-swatch-expand]').forEach(function (btn) {
        var prefetchOverflow = function () {
          preloadOverflowSwatchImages(root);
        };

        btn.addEventListener('mouseenter', prefetchOverflow, { once: true });
        btn.addEventListener('touchstart', prefetchOverflow, { once: true, passive: true });
        btn.addEventListener('focus', prefetchOverflow, { once: true });

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          preloadOverflowSwatchImages(root);
          var expanded = root.classList.toggle('is-swatch-expanded');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (expanded) {
            window.requestAnimationFrame(function () {
              preloadOverflowSwatchImages(root);
            });
          } else {
            layoutSwatchOverflow(root);
          }
        });
      });

      layoutSwatchOverflow(root);
      observeSwatchRow(root);

      if (!priceEl) return;

      root.querySelectorAll('[data-bestsellers-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          applySwatch(root, btn, img, priceEl);
          layoutSwatchOverflow(root);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    window.requestAnimationFrame(function () {
      document.querySelectorAll('.bestsellers-consolidated--var-2 [data-bestsellers-consolidated]').forEach(layoutSwatchOverflow);
    });
    window.setTimeout(function () {
      document.querySelectorAll('.bestsellers-consolidated--var-2 [data-bestsellers-consolidated]').forEach(layoutSwatchOverflow);
    }, 200);
    window.addEventListener('load', function () {
      document.querySelectorAll('.bestsellers-consolidated--var-2 [data-bestsellers-consolidated]').forEach(layoutSwatchOverflow);
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('.bestsellers-consolidated--var-2 [data-bestsellers-consolidated]').forEach(layoutSwatchOverflow);
    }, 120);
  });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
